import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Home' 
    },
    {
      path: '/Home',
      name: 'home',
      component: ()=>import("../view/Home.vue")
    },
    {
      path:'/About',
      name:'about',
      component:()=>import("../view/About.vue")
    },
    {
      path:'/Contact',
      name:'contact',
      component:()=>import("../view/Contact.vue")
    },
    {
      path:'/Information',
      name:'information',
      component:()=>import("../view/Information.vue")
    },
    {
      path:'/Project',
      name:'project',
      component:()=>import("../view/AccessoryProject.vue")
    },
    {
      path:'/Service',
      name:'service',
      component:()=>import("../view/Service.vue")
    },
    {
      path:'/Show',
      name:'show',
      component:()=>import("../view/Show.vue")
    },
    {
      path:'/fmtl',
      name:'name',
      component:()=>import("../view/allproduct/Fmtl.vue")
    },
    {
      path:'/fzcl',
      name:'fzcl',
      component:()=>import("../view/allproduct/Fzcl.vue")
    },
    {
      path:'/gxqcq',
      name:'gxqcq',
      component:()=>import("../view/allproduct/Gxqcq.vue")
    },
    {
      path:'/gyfhq',
      name:'gyfhq',
      component:()=>import("../view/allproduct/Gyfhq.vue")
    },
    {
      path:'/hgcp',
      name:'hgcp',
      component:()=>import("../view/allproduct/Hgcp.vue")
    },
    {
      path:'/sxq',
      name:'sxq',
      component:()=>import("../view/allproduct/Sxq.vue")
    },
    {
      path:'/tsytfhq',
      name:'tsytfhq',
      component:()=>import("../view/allproduct/Tsytfhq.vue")
    },
    {
      path:'/yxbx',
      name:'yxbx',
      component:()=>import("../view/allproduct/Yxbx.vue")
    },
    {
      path:'/zffq',
      name:'zffq',
      component:()=>import("../view/allproduct/Zffq.vue")
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js